<template>
    <div>
        <span v-if="modelValue" class="text-muted">{{field.translation.label}}</span>
        <base-input
            :class="`${errors.has(`field_${field.id}`) ? 'invalid-text' : ''}`"
            :error="customError(errors.first(`field_${field.id}`))"
            v-model="inputValue"
            @input="e => formatToIso(e)"
            :placeholder="field.translation.label"
            v-validate="{ required: field.data.required, regex: checkValidation && /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/ }"
            :name="`field_${field.id}`"
            v-mask="'##/##/####'"
            >
            <template #append><vc-date-picker
                locale="pt-br"
                @input="e => datePickerSelect(e)"
                :popover="{ placement: 'bottom', visibility: 'click' }"
                :value="datepickerValue">
                <span>
                    <i class="mdi mdi-calendar fa-1x"></i>
                </span>
            </vc-date-picker></template>
        </base-input>
    </div>
</template>

<script>

import BaseInput from '../../../argon/components/Inputs/BaseInput'

export default {
    emits: ['input', 'update:modelValue'],
    name: "DatePickerRegister",

    components: {
        BaseInput,
    },

    props: {
        modelValue: [String, Number],
        field: Object,
    },
    
    data(){
        return {
            inputValue: this.modelValue ? this.$moment(this.modelValue).format('L')  : "",
            checkValidation: true
        }
    },

    computed: {
        model: {
            get(){
                return this.modelValue
            },
            set(value){
                this.$emit('update:modelValue',value)
            }
        },

        datepickerValue(){
            return this.$moment(this.model).toDate()
        },
    },

    methods: {
        customError(err) {
            if (err) {
                if (this.inputValue.length == 0){
                    return this.$t('common.required_field')
                }
                return this.$t('common.invalid_format')
            }
        },
        datePickerSelect(e){
            this.model = e.toISOString().substr(0,10);
            this.inputValue = this.$moment(e).format('L');
        },
        formatToIso(e){
            if(e.length == 10 && /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/.test(e)){
                this.model = `${e.substr(6,4)}-${e.substr(3,2)}-${e.substr(0,2)}`
            }
            if(this.field.data.required || e.length != 0){
                this.checkValidation = true;
            }else{
                this.checkValidation = false;
            }
        }
    },
}
</script>

<style scoped>
.text-muted{
    font-size: .9rem;
    margin-left: 4px;
}
</style>